import * as tslib_1 from "tslib";
import { HttpHeaders } from '@angular/common/http';
/**
 * Inicialización de la función loadResources, carga los recursos necesarios de la aplicación
 *
 * *Set loadResources interface, loads the necessary resources of the application*
 *
 * @access public
 * @type {function}
 */
export function loadResources(mockService, endpointService, parametersService, copyService, platformCommunicatorService) {
    var _this = this;
    return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, configAPIResources(endpointService, mockService)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, loadApplicationsParametersAndRules(parametersService, platformCommunicatorService)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, copyService.loadCopies()];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
}
/**
 * Función asincrona que configura los recursos de la aplicación
 *
 * *Async function that configures app's API resources*
 *
 * @access public
 * @type {function}
 */
function configAPIResources(endpointService, mockService) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, endpointService.loadURLS()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, endpointService.loadMICRO()];
                case 2:
                    _a.sent();
                    mockService.setMocks();
                    return [2 /*return*/];
            }
        });
    });
}
function paramedtrizedHeaders(headersParametrized, platformCommunicatorService) {
    var headers = new HttpHeaders({});
    Object.entries(headersParametrized).forEach(function (key) {
        headers = headers.append(key[0], key[1]);
    });
    platformCommunicatorService.setParametrizedHeaders(headers);
}
/**
 * Carga toda la configuración de la aplicación. Carga los parámetros de configuración
 * de la aplicación y las reglas de negocio.
 *
 * @access public
 * @type {function}
 * @param parametersService Servicio encargado de manejar la configuración de la aplicación
 * @param platformCommunicatorService Servicio encargado de manejar la comunicación con el Backend.
 */
function loadApplicationsParametersAndRules(parametersService, platformCommunicatorService) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, parametersService.loadApplicationParameters()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, parametersService.loadBusinessRules()];
                case 2:
                    _a.sent();
                    // await parametersService.loadApplicationSettings();
                    return [4 /*yield*/, parametersService.loadBiocatchContext()];
                case 3:
                    // await parametersService.loadApplicationSettings();
                    _a.sent();
                    paramedtrizedHeaders(parametersService.getParameter('headers'), platformCommunicatorService);
                    return [2 /*return*/];
            }
        });
    });
}
